import { DataBean } from "../../DataBean";


export class PopulationType extends DataBean {

    public async getPopulationTypeList(args: any): Promise<any> {
        return this.getCustomService("OrangeBase", "java.util.List_getPopulationTypeList_Number", [args]);
    }

}